<div id="dashboard-analytics" class="page-layout blank">
    <div class="content">
        <div class="p-16">
            <h2>Lista zmian - 12.03.2024</h2>
            <ul>
                <li>Obsługa prostych karnetów - konfiguracja ilości kredytów na karnecie.</li>
                <li>Możliwość ustawienia wymaganych kredytów przez usługę.</li>
                <li>Możliwość ustawienia wymaganych kredytów przez urządzenie.</li>
                <li>Uzupełnienie części tłumaczeń na język polski.</li>
                <li>Dodano wymaganie numeru NIP po zaznaczeniu, że klient chce otrzymać fakturę VAT.</li>
                <li>Rozbudowano API dla aplikacji mobilnej.</li>
            </ul>

            <h2>Lista zmian - 08.01.2024</h2>
            <ul>
                <li>Optymalizacja odczytu danych użytkownika.</li>
                <li>Możliwość konfiguracji cyklicznego doładowywania kart.</li>
                <li>Możliwość odejmowania usług/zabiegów.</li>
            </ul>

            <h2>Lista zmian - 21.11.2023</h2>
            <ul>
                <li>Dodano obsługę programu PZU Sport.</li>
                <li>Dodano obsługę programu ProFit.</li>
            </ul>

            <h2>Lista zmian - 24.10.2023</h2>
            <ul>
                <li>Optymalizacja zapisu oraz aktualizacji karnetu.</li>
                <li>Dodano tłumaczenia pól do formularza edycji karnetu.</li>
                <li>Dodano tłumaczenia pól do formularza edycji grup karnetu.</li>
            </ul>

            <h2>Lista zmian - 23.10.2023</h2>
            <ul>
                <li>Poprawiono zapis rezerwacji w kalendarzu.</li>
                <li>Poprawiono listę użytkowników online.</li>
                <li>Dodano sprawdzanie czy aplikacja sterująca wydrukiem na drukarce fiskalnej jest aktywna.</li>
            </ul>

            <h2>Lista zmian - 05.10.2023</h2>
            <ul>
                <li>Dodano możliwość konfiguracji ważności karnetów w wybrane dni tygodnia.</li>
            </ul>

            <h2>Lista zmian - 04.10.2023</h2>
            <ul>
                <li>Dodano możliwość konfiguracji ważności karnetów w wybranych godzinach.</li>
            </ul>

            <h2>Lista zmian - 03.10.2023</h2>
            <ul>
                <li>Dodano podwójną akceptację zmian w edycji karnetów.</li>
                <li>Dodano podgląd logów karnetów.</li>
                <li>Dodano podgląd logów produktów.</li>
            </ul>

            <h2>Lista zmian - 25.09.2023</h2>
            <ul>
                <li>Kontrola ilości otwartych zakładek/okien.</li>
            </ul>

            <h2>Lista zmian - 21.09.2023</h2>
            <ul>
                <li>Dodano możliwość dodawania karnetów na pierwszy trening z poziomu widoku karty klienta.</li>
            </ul>

            <h2>Lista zmian - 19.09.2023</h2>
            <ul>
                <li>Licznik ważności sesji użytkownika</li>
            </ul>

            <h2>Lista zmian - 18.09.2023</h2>
            <ul>
                <li>Dodano możliwość dodania karnetu na pierwszy trening w innym terminie niż dodanie klienta do bazy danych</li>
                <li>Szybkie dodawanie uczestników do treningów</li>
                <li>Szybki podgląd listy uczestników treningu</li>
            </ul>

            <h2>Lista zmian - 04.09.2023</h2>
            <ul>
                <li>W historii karty została dodana prezentacja informacji o dodanym karnecie</li>
                <li>Dodano płatnosci mobilne w API</li>
                <li>Dodano możliwość usunięcia uczestnika zajęć grupowych</li>
                <li>Dodano obsługę MediCover Plus</li>
            </ul>

            <h2>Lista zmian - 08.08.2023</h2>
            <ul>
                <li>Dodano możliwość usuwania grup karnetów</li>
            </ul>

            <h2>Lista zmian - 07.08.2023</h2>
            <ul>
                <li>Poprawka dla zakupów przez sklep internetowy w przypadku gdy klientka zwróciła kartę</li>
                <li>Pracownik może być jednocześnie trenerem</li>
            </ul>

            <h2>Lista zmian - 02.08.2023</h2>
            <ul>
                <li>Poprawa w edycji użytkowników - już można zapisać dane użytkownika bez podawania hasła za każdym razem</li>
                <li>Możliwość ukrycia urządzenia w kalendarzu - w urządzeniu odznaczamy "Uruchom kalendarz", następnie klikamy "Zapisz"</li>
                <li>Przywrócono możliwość zapisu notatki do zdarzenia w kalendarzu</li>
                <li>Usunięcie błędu
                    "Expected argument of type \"?Doctrine\\Common\\Collections\\Collection\", \"array\" given at property path \"participants\"."</li>
                <li>Poprawka do edycji grup karnetów</li>
            </ul>

            <h2>Lista zmian - 01.08.2023</h2>
            <ul>
                <li>Konfiguracja widoczności użytkownika/urządzenia w kalendarzu</li>
                <li>Poprawka do logowania kartą</li>
            </ul>

            <h2>Lista zmian - 31.07.2023</h2>
            <ul>
                <li>Powiększono okno dodawania karnetu</li>
            </ul>

            <h2>Lista zmian - 27.07.2023</h2>
            <ul>
                <li>Poprawka do zdejmowania akceptacji wyjścia z karty</li>
                <li>Poprawka do otwierania bramki wejściowej</li>
                <li>Dodano wyszukiwanie klientów bez konieczności użycia polskich znaków</li>
            </ul>

            <h2>Lista zmian - 20.07.2023</h2>
            <ul>
                <li>Dodano uprawnienia do notatek</li>
                <li>Poprawki w module trenera</li>
                <li>Poprawki w nawigacji</li>
                <li>Poprawki związane z usuwaniem pracowników</li>
                <li>Dodano możliwość oznaczania kart jako zwrócone</li>
            </ul>

            <h2>Lista zmian - 18.07.2023</h2>
            <ul>
                <li>Zajęcia grupowe w kalendarzu są oznacza w innym kolorze</li>
                <li>Możliwość zalogowania się przez trenera</li>
                <li>Możliwość dodawania zajęć grupowych</li>
                <li>Możliwość dodawania uczestników do zajęć grupowych</li>
                <li>Możliwość potweirdzenia uczestnictwa w zajęciach grupowych</li>
                <li>Odejmowanie usług MultiSport oraz Medicover w momencie wyjścia z klubu</li>
                <li>Przedłużenie czasu zalogowania jeśli nastąpi ruch na ekranie</li>
                <li>Poprawka błędu w dodawaniu/odejmowaniu usług</li>
                <li>Edycja kategorii usługi</li>
                <li>Możliwość przewijania usług</li>
                <li>Możliwość usuwania kont pracowników</li>
                <li>Mechanizm informowania o zmianach</li>
            </ul>
        </div>
    </div>
</div>
